import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice_data: props.invoice_data || null,
      data: props.data || null,
      isLoadingInvoiceInfo: true,
      invoice_numbers:null,
      setJobAsReadyToBeInvoiceLoading:false
    };

    this.handleJobInvoiceNumberChange = this.
      handleJobInvoiceNumberChange.bind(this);
  }

  componentDidMount() {
    this.getInvoiceInfo();
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).
    listen(
      'InvoiceInfoChanged',
      (e) => {
        this.getInvoiceInfo();
      }
    );
  }
  handleJobInvoiceNumberChange(e) {
    let newJobInvoiceNumber = e.target.value;
    let data = {...this.state.data};
    data.invoice_number = newJobInvoiceNumber;
    this.setState({data});
  }

  getInvoiceInfo() {
    let url = '/api/v1/portal/invoice-info/job/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((invoiceInfoJson) => {
        this.setState({
          invoice_data: invoiceInfoJson['invoice_data'],
          isLoadingInvoiceInfo: false,
          invoice_numbers:invoiceInfoJson['invoiced_numbers'],
        })
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }


  changeInvoiceNumber(e) {
    let newInvoiceNumber = e.target.value;
    let changeInvoiceNumber = confirm(
      'change InvoiceNumber to '+ newInvoiceNumber + '?'
    );

    if (changeInvoiceNumber) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-invoice-number/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          invoice_number: newInvoiceNumber
        },
        cache: false,
        method: 'post',
      })
        .done(function(data) {
          //  alert('cancelled');
        });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=invoice_number]").
      val(e.target.value);
    }
  }
  handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(e, i) {
    this.getZipDownloadForJobs(i);
  }
  getZipDownloadForJobs(jobIncludeInZip) {

    this.setState({
      selectedJobsZipping: true
    });

    return fetch(
      '/api/v1/portal/appraisal-expense-invoice-info/job/'
      +jobIncludeInZip+'/combined-appraisal-expense-zip-download',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
        body: JSON.stringify({
          jobsToIncludeInZip: jobIncludeInZip
        }),
      }
    ).then(
      (responseText) => {
        let response = responseText.json();
        response.then((customerJobZip) => {
          if (customerJobZip.zip) {
            this.downloadZIP(customerJobZip.zip);
          }
        });
      }
    );
  }
  downloadZIP(zipFile) {
    this.setState({
      selectedJobsZipping: false
    });
    window.location = zipFile;
  }
  setJobAsReadyToBeInvoiced() {
    this.setState({setJobAsReadyToBeInvoiceLoading:true});  
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
    }.bind(this));
  }
  setJobAsNotReadyToBeInvoiced() {
    this.setState({setJobAsReadyToBeInvoiceLoading:true});
    $.ajax({
      url: "/api/v1/portal/jobs/set-as-not-ready-to-be-invoiced/"+
        this.state.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
    .done(function(data) {
        this.setState({setJobAsReadyToBeInvoiceLoading:false});
    }.bind(this));
  }
  render() {
    let invoiceInfoBlock;
    let InvoiceLines = [];
    let InvoiceNumbers = [];
    invoiceInfoBlock = (
      <p><strong>No invoice available.</strong></p>
    );
    
    let invoiceRow = 0;
    if (this.state.invoice_data && (this.state.invoice_data.length > 0)) {
      if(this.state.invoice_numbers && (this.state.invoice_numbers.length > 0)){
        this.state.invoice_numbers.forEach(function(num) {
          InvoiceNumbers.push(
            <tr key={num.id}>
              <td><a href={"/jobs/view/"+num.id} target="_blank">{num.id}</a></td>
              <td>{num.invoice_number}</td>
            </tr>
          );
        });
      }
      let jobId = this.state.data.id;
      this.state.invoice_data.forEach(function(i) {
        invoiceRow++;
        InvoiceLines.push(
          <>
          <div className="row" key={'job-'+jobId+'-invoice-service-row-'+invoiceRow}>
            <div className="col-md-1">{i.ACCOUNT_REF}</div>
            <div className="col-md-1">{i.NOMINAL_CODE}</div>
            <div className="col-md-1">{i.QTY_ORDER}</div>
            <div className="col-md-1">{i.NET_AMOUNT}</div>
            <div className="col-md-1">{i.SERVICE_AMOUNT}</div>
            <div className="col-md-4">{i.SERVICE_TEXT}</div>
            <div className="col-md-1">{i.TAX_AMOUNT}</div>
            <div className="col-md-1">{i.TAX_CODE}</div>
            <div className="col-md-1">{i.INVOICE_TYPE}</div>
          </div>
          {i.HIRE_ONLY_WEEK_COST != "0.00" && (
          <div className="row" key={'job-'+jobId+'-invoice-hireonly-row-'+invoiceRow}>
            <div className="col-md-1">{i.ACCOUNT_REF}</div>
            <div className="col-md-1">{i.NOMINAL_CODE}</div>
            <div className="col-md-1">{i.HIRE_ONLY_WEEK_QUANTITIES}</div>
            <div className="col-md-1">{i.HIRE_ONLY_WEEK_COST}</div>
            <div className="col-md-1">{i.HIRE_ONLY_WEEK_SERVICE_AMOUNT}</div>
            <div className="col-md-4">Hire Only Week cost <br/> { i.HIRE_ONLY_WEEK_DATES }</div>
            <div className="col-md-1">{i.HIRE_ONLY_WEEK_TAX_AMOUNT}</div>
            <div className="col-md-1">{i.TAX_CODE}</div>
            <div className="col-md-1">{i.INVOICE_TYPE}</div>
          </div>
          )}
          {i.DELIVERY_COST != "0.00" && (
            <div className="row" key={'job-'+jobId+'-invoice-delivery-row-'+invoiceRow}>
              <div className="col-md-1">{i.ACCOUNT_REF}</div>
              <div className="col-md-1">{i.NOMINAL_CODE}</div>
              <div className="col-md-1">{i.QTY_ORDER}</div>
              <div className="col-md-1">{i.DELIVERY_COST}</div>
              <div className="col-md-1">{i.DELIVERY_SERVICE_AMOUNT}</div>
              <div className="col-md-4">delivery cost</div>
              <div className="col-md-1">{i.DELIVERY_TAX_AMOUNT}</div>
              <div className="col-md-1">{i.TAX_CODE}</div>
              <div className="col-md-1">{i.INVOICE_TYPE}</div>
            </div>
          )}
          {i.COLLECTION_COST != "0.00" && (
            <div className="row" key={'job-'+jobId+'-invoice-collection-row-'+invoiceRow}>
              <div className="col-md-1">{i.ACCOUNT_REF}</div>
              <div className="col-md-1">{i.NOMINAL_CODE}</div>
              <div className="col-md-1">{i.QTY_ORDER}</div>
              <div className="col-md-1">{i.COLLECTION_COST}</div>
              <div className="col-md-1">{i.COLLECTION_SERVICE_AMOUNT}</div>
              <div className="col-md-4">collection cost</div>
              <div className="col-md-1">{i.COLLECTION_TAX_AMOUNT}</div>
              <div className="col-md-1">{i.TAX_CODE}</div>
              <div className="col-md-1">{i.INVOICE_TYPE}</div>
            </div>
          )}
          
          </>
        )
      });

      invoiceInfoBlock = (
        <div className="jobs-table-invoice-container"
             key={'job-'+jobId+'-invoice'}>

          <div className="jobs-table-invoice-number-input-container">
            <label>Invoice Number:</label>
            <input
              type="text"
              className="jobs-table-editable form-control form-control-lg"
              value={this.state.data.invoice_number}
              onChange={this.handleJobInvoiceNumberChange}
              onBlur={(e) => this.changeInvoiceNumber(e)}
              placeholder="invoice #"
              name="invoice_number" />
          </div>
          <div className="row">
          { (this.state.invoice_numbers && (this.state.invoice_numbers.length > 0)) ? 
                <div className="col-md-3 no-border">
                  <label>Parent/Child jobs with invoice numbers:</label>
                    <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Job</th>
                        <th>Invoice Number.</th>
                      </tr>
                    </thead>
                    <tbody>
                    {InvoiceNumbers} 
                    </tbody>
                    </table>
                    <br/>
                </div>
                :'' }
          </div>
          <div className="row">
            <div className="col-md-1">Account Ref</div>
            <div className="col-md-1">Nominal Code</div>
            <div className="col-md-1">Qty Order</div>
            <div className="col-md-1">Net Amount</div>
            <div className="col-md-1">Total Price</div>
            <div className="col-md-4">Service Text</div>
            <div className="col-md-1">Tax Amount</div>
            <div className="col-md-1">Tax Code</div>
            <div className="col-md-1">Invoice Type</div>
          </div>
          {InvoiceLines}
          <br />
          <div className="row">
            <div className="col-md-12 no-border">
              {(this.state.data.ready_for_invoice === 1) ?
                  <div className="text-right">
                    <p>
                      <strong>Job ready to be invoiced</strong>
                    </p>
                    <p>
                      <button
                        className="btn btn-lg btn-warning"
                        disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? 'disabled':''}
                        onClick={() => {
                          this.setJobAsNotReadyToBeInvoiced(
                            this.state.data.id
                          )
                        }}>
                        Set Job as not ready to be invoiced
                      </button>
                    </p>
                  </div>
                  :
                  <div className="text-right">
                    <p>
                      <strong>Job not ready to be invoiced</strong>
                    </p>
                    <p>
                      <button
                        className="btn btn-lg btn-primary"
                        disabled={(this.state.setJobAsReadyToBeInvoiceLoading) ? 'disabled':''}
                        onClick={() => {
                          this.setJobAsReadyToBeInvoiced(
                            this.state.data.id
                          )
                        }}>
                        Set Job as ready to be invoiced
                      </button>
                    </p>
                  </div>
                }
              </div>
          </div>

          <br />
          &nbsp;&nbsp;
          <a className="btn btn-lg btn-success pull-right"
             href={"/api/v1/portal/invoice-info/job/"+jobId+
             '/csv?api_token='+window.api_token}
             target="_blank"
          >
            <i className="fa fa-download"></i> Download Sage CSV
          </a>
          <button   
            className="btn btn-lg btn-outline-success customer-invoicing-combined-assets-download"
            onClick={(e) => {
             e.preventDefault();
             this.handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(
               e, jobId
             );
            }}
            disabled={this.state.selectedJobsZipping === true}
          >
          <i className="fa fa-download"></i>&nbsp;
          <i className="fa fa-file-archive"></i>&nbsp;
          Download Appraisals for the job into ZIP
            &nbsp;&nbsp;
            {
              (this.state.selectedJobsZipping === true) ?
                <i className="fas fa-cog fa-spin"></i>
                :
                ''
            }

          </button>
          <br />
        </div>
      );
    }
    return (
      this.state.isLoadingInvoiceInfo ?
      (<div className="loading-box">
                      <span className="add-loading-text">
                      <i className="fa fa-spinner fa-pulse"></i>
                      </span></div>) :
      invoiceInfoBlock
    );
  }
}